export enum OPT_IN_FLOW_RESPONSE_STATUS {
  STATUS_CREATED = 201,
  STATUS_SUCCESS = 200,
  STATUS_NO_CONTENT = 204,
  STATUS_FORBIDDEN = 403,
  STATUS_FAIL = 500,
  STATUS_BAD_REQUEST = 400,
  STATUS_CONFLICT = 409
}

export const loDspOptinSource: string = "web";

export const successOptInStatuses: Array<OPT_IN_FLOW_RESPONSE_STATUS> = [
  OPT_IN_FLOW_RESPONSE_STATUS.STATUS_SUCCESS,
  OPT_IN_FLOW_RESPONSE_STATUS.STATUS_CREATED,
  OPT_IN_FLOW_RESPONSE_STATUS.STATUS_CONFLICT,
  OPT_IN_FLOW_RESPONSE_STATUS.STATUS_NO_CONTENT
];

export const successCreateOptInStatuses: Array<OPT_IN_FLOW_RESPONSE_STATUS> = [
  OPT_IN_FLOW_RESPONSE_STATUS.STATUS_SUCCESS,
  OPT_IN_FLOW_RESPONSE_STATUS.STATUS_CREATED
];
